import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '@/lib/utils';

export const Tabs = TabsPrimitive.Root;

export const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'inline-flex items-center gap-1 p-1 rounded-fd-sm',
      'bg-fd-surface-1 border border-fd-border',
      className,
    )}
    {...props}
  />
));
TabsList.displayName = 'TabsList';

export const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'inline-flex items-center justify-center gap-2 px-3 h-7 rounded-[6px]',
      'font-geist text-[12.5px] font-medium text-fd-text-muted',
      'transition-[background,color] duration-fd-fast ease-fd-out',
      'hover:text-fd-text',
      'data-[state=active]:bg-fd-surface-2 data-[state=active]:text-fd-text',
      'data-[state=active]:shadow-[inset_0_0_0_1px_var(--fd-border)]',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-fd-accent focus-visible:ring-offset-2 focus-visible:ring-offset-fd-bg',
      'disabled:opacity-50 disabled:pointer-events-none',
      className,
    )}
    {...props}
  />
));
TabsTrigger.displayName = 'TabsTrigger';

export const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn('mt-4 focus-visible:outline-none', className)}
    {...props}
  />
));
TabsContent.displayName = 'TabsContent';
